// CANONICAL COPY (GH #7115). src/constants/obligations/obl-management-body-accountability.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-management-body-accountability',
  title: 'Verify management body cybersecurity oversight and training',
  description:
    'Confirm that the management body has approved cybersecurity risk-management measures, oversees their implementation, and that its members have completed cybersecurity training. Required by NIS2 Article 20 — management body members may be held personally liable for infringements. A role definition flagged managementBody:true designates the management body in the Employees module; every active member must have JML security-training complete and (if a training-attestation evidence requirement exists) hold a verified, in-date attestation.',
  category: 'governance',
  scfIds: ['SCF-GOV-012'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'management-body-trained',
      description:
        'Management body designated and every member has completed cybersecurity training',
    },
    {
      type: 'document-published',
      description:
        'Management body accountability / cybersecurity governance document is published',
    },
    { type: 'document-approved', description: 'Document has been approved by the management body' },
  ],
  domainActions: [
    { type: 'deep-link', target: 'employees', label: 'Review Employee Records' },
    { type: 'approve-document', label: 'Approve Document' },
    { type: 'upload-artefact', label: 'Upload Training Evidence' },
  ],
};
